/* QUANTICA · <q-head>
 *
 * Auto-ocultado del header flotante. Pedido del 23/09 desde la revision
 * mobile: la barra tapa el titular de cada seccion mientras se scrollea.
 *
 * COMPORTAMIENTO. Se esconde mientras se BAJA, y vuelve cuando se sube o
 * cuando el scroll se DETIENE. Lo segundo no es el patron habitual —lo
 * normal es que vuelva solo al subir— y esta pedido asi expresamente: la
 * barra tiene que estar cuando la persona frena a leer. El tiempo de
 * quietud es un setting; en 0 se comporta como el patron clasico.
 *
 * Arriba de todo la barra no se esconde nunca: en el hero el header es
 * parte del diseno, y esconderlo al primer toque de rueda se ve como un
 * parpadeo.
 *
 * Se lee la posicion en requestAnimationFrame y se marca con un atributo;
 * el movimiento lo hace el CSS, que respeta prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (customElements.get('q-head')) return;

  class QHead extends HTMLElement {
    connectedCallback() {
      if (this.arrancado) return;
      this.arrancado = true;

      if (this.getAttribute('data-autohide') !== 'on') return;

      this.espera = parseInt(this.getAttribute('data-autohide-delay'), 10);
      if (isNaN(this.espera)) this.espera = 180;

      this.piso = parseInt(this.getAttribute('data-autohide-floor'), 10);
      if (isNaN(this.piso)) this.piso = 90;

      this.ultimo = window.pageYOffset || 0;
      this.pedido = false;
      this.alScroll = this.alScroll.bind(this);

      window.addEventListener('scroll', this.alScroll, { passive: true });

      /* requestAnimationFrame no corre mientras la pestana esta oculta, y
         un cuadro pedido justo antes de ocultarla queda pendiente. Al
         volver, `pedido` seguiria en true y el listener ignoraria todo
         scroll posterior: la barra quedaria congelada. Se limpia la
         bandera al volver a primer plano y se relee la posicion, que
         ademas pudo cambiar mientras no se miraba. */
      this.alVolver = this.alVolver.bind(this);
      document.addEventListener('visibilitychange', this.alVolver);
    }

    disconnectedCallback() {
      if (this.alScroll) window.removeEventListener('scroll', this.alScroll);
      if (this.alVolver) document.removeEventListener('visibilitychange', this.alVolver);
      clearTimeout(this.reloj);
    }

    alVolver() {
      if (document.hidden) return;
      this.pedido = false;
      this.ultimo = window.pageYOffset || 0;
      this.mostrar();
    }

    alScroll() {
      if (this.pedido) return;
      this.pedido = true;

      var correr = this.mirar.bind(this);
      if (window.requestAnimationFrame) window.requestAnimationFrame(correr);
      else setTimeout(correr, 16);
    }

    mirar() {
      this.pedido = false;

      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var dif = y - this.ultimo;

      /* El umbral de 6 px evita que el rebote elastico de iOS, que mueve
         uno o dos pixeles solo, dispare el escondido. */
      if (y <= this.piso) {
        this.mostrar();
      } else if (dif > 6) {
        this.esconder();
      } else if (dif < -6) {
        this.mostrar();
      }

      this.ultimo = y;

      /* Vuelve al frenar. El reloj se reinicia en cada cuadro de scroll,
         asi que solo llega al final cuando el movimiento realmente paro. */
      clearTimeout(this.reloj);
      if (this.espera > 0) {
        this.reloj = setTimeout(this.mostrar.bind(this), this.espera);
      }
    }

    esconder() {
      /* Con un menu desplegado o el buscador abierto, esconder la barra se
         lleva puesto lo que la persona tiene abierto. */
      if (this.querySelector('[aria-expanded="true"]')) return;
      this.setAttribute('data-off', '');
    }

    mostrar() {
      this.removeAttribute('data-off');
    }
  }

  customElements.define('q-head', QHead);
})();
